import React from 'react'

export default function Code(props) {
  return <pre>{props.children}</pre>
}
